<template functional>
  <div style="align-content: center">
    <template v-if="props.row.zip_code">
      <strong><translate-text keyTranslate="common_words.zip_code" />: </strong>
      {{ props.row.zip_code ? props.row.zip_code : 'NA' }}
      <br />
    </template>
    <strong><translate-text keyTranslate="common_words.address" />: </strong>
    {{ props.row.address ? props.row.address : 'NA' }}
    <br />
    <strong><translate-text keyTranslate="common_words.country" />: </strong>
    {{ props.row.country }}
    <br />
    <strong><translate-text keyTranslate="common_words.state" />: </strong>
    {{ props.row.state }}
    <br />
    <strong><translate-text keyTranslate="common_words.city" />: </strong>
    {{ props.row.city }}
    <br />
  </div>
</template>

<script>
export default {
  name: 'AddressFormatterFunctional',
};
</script>
